// AdvanceFilter Container Component
// This file provides the container logic for the AdvanceFilter presentational component.
// It fetches filter data and handles loading/error states.

import { useFilters } from "@/hooks/use-filters";
import { Filter } from "@/types/order-table";
import AdvanceFilter from "./presentational";
import Loader from "@components/Loader";

/**
 * Props for the AdvanceFilterContainer component
 */
interface Props {
  type: Filter;
  currentTable?: string;
  closeModal?: () => void;
}

/**
 * AdvanceFilterContainer Component
 * Fetches available filter options and displays the AdvanceFilter UI.
 * Handles loading and error states using the Loader component.
 *
 * @param type - The filter type (e.g., 'orderName', 'provider')
 * @param currentTable - Optional table identifier for context
 * @param closeModal - Optional callback to close the modal
 */
const AdvanceFilterContainer = ({ type, currentTable, closeModal }: Props) => {
  // Fetch filter data and loading/error state using custom hook
  const {
    data = [],
    isPending,
    isError,
    error,
  } = useFilters(type, currentTable);

  return (
    <Loader
      isLoading={isPending}
      displayText="Checking Available Filters"
      isError={isError}
      errorReason={error?.message}
    >
      {/* Only render AdvanceFilter if data is available */}
      {!!data.length && (
        <AdvanceFilter
          closeModal={closeModal}
          type={type}
          originalList={data}
        />
      )}
    </Loader>
  );
};

export default AdvanceFilterContainer;
